<template>
    <div>
        <JobFormMap
            v-if="isAreaReady"
            :google-api-key="maps.google_api_key"
            :area-id="tab_form.area_id"
            :maps-url="maps.maps_url"
            :is-tr-user="true"
            :has-error="mapsHasError"
        />

        <el-row>
            <el-col :span="24">
                <h2 class="tr-mt">Audience</h2>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="Min Experience">
                    <el-select v-model="tab_form.min_cdl_xp" style="width:100%" required="required">
                        <el-option
                            v-for="option in globals.cdl_xp"
                            :value="option.id"
                            :label="option.name"
                            :key="`min-xp-${option.id}`"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="Max Experience">
                    <el-select v-model="tab_form.max_cdl_xp" style="width:100%">
                        <el-option
                            v-for="option in globals.cdl_xp"
                            :value="option.id"
                            :label="option.name"
                            :key="`max-xp-${option.id}`"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <proposal-categories :tab_form="tab_form"></proposal-categories>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import JobFormMap from '../../../../maps/vue/map.vue';
import ProposalCategories from './proposal-tab-jobs-categories';

export default {
    components: {
        JobFormMap,
        ProposalCategories
    },
    props: {
        proposal: {
            type: Object,
            required: true
        },
        tab_form: {
            type: Object,
            required: true
        },
        maps: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            mapsHasError: false,
            isAreaReady: false,
        };
    },
    watch: {
        'tab_form.area_id'(newValue) {
            if (newValue === null) {
                this.refreshAreaSession();
            }
        }
    },
    methods: {
        refreshAreaSession() {
            this.isAreaReady = false;

            axios.post(this.url(`admin/area/start-session`), {
                proposal2_id: this.proposal.id
            }).then(response => {
                this.tab_form.area_id = response.data.id;

                this.isAreaReady = true;
            });
        }
    },
    mounted() {
        this.refreshAreaSession();
    }
}
</script>